<template>
  <modal
    :show.sync="showAndClose"
    bodyClasses="pt-0"
    size="lg"
    @close="closeModal"
  >
    <template slot="header">
      <h6 class="subtitle" id="modal-title-default">
        New Customer
        <el-popover placement="bottom" trigger="hover" width="300" class="curp">
          <span>
            This form is used to add a customer quickly. For more options add
            the field from
            <router-link to="/customers/new">Customers</router-link>
          </span>
          <div class="badge badge-primary" slot="reference">?</div>
        </el-popover>
      </h6>
    </template>

    <div class="row forms mt-4">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <label for="title" class="title-label">Type</label>

        <b-form-group v-slot="{ ariaDescribedby2 }">
          <b-form-radio-group
            id="radio-types"
            v-model="type"
            :aria-describedby="ariaDescribedby2"
            name="radio-types"
            buttons
            button-variant="outline-neutral"
            size="md"
            :options="types"
            value-field="value"
            text-field="label"
          >
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div class="col-12" v-if="type != 'travel_agency'"></div>
      <div
        class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12"
        v-if="type === 'travel_agency'"
      >
        <base-input
          v-model.trim="$v.customer.company_name.$model"
          label="Business Name"
          placeholder="Business Name"
          id="bussiness_name"
          name="bussiness_name"
          inputClasses="text-capitalize"
          indexTab="2"
          :error="
            !$v.customer.company_name.minLength ||
            $v.customer.company_name.$error
              ? `Minimum ${$v.customer.company_name.$params.minLength.min} letters.`
              : ''
          "
          markrequired
        />
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <base-input
          v-model.trim="$v.customer.first_name.$model"
          inputClasses="text-capitalize"
          label="First Name"
          placeholder="First Name"
          id="ncfirst_name_passenger"
          name="ncfirst_name_passenger"
          indexTab="2"
          :error="
            !$v.customer.first_name.minLength || $v.customer.first_name.$error
              ? `Minimum ${$v.customer.first_name.$params.minLength.min} letters.`
              : ''
          "
          markrequired
        />
      </div>

      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <base-input
          v-model.trim="$v.customer.last_name.$model"
          label="Last Name"
          inputClasses="text-capitalize"
          placeholder="Last Name"
          id="nclast_name_passenger"
          name="nclast_name_passenger"
          indexTab="3"
          :error="
            !$v.customer.last_name.minLength || $v.customer.last_name.$error
              ? `Minimum ${$v.customer.last_name.$params.minLength.min} letters.`
              : ''
          "
          markrequired
        />
      </div>

      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 mb-4">
        <label for="title" class="title-label">Title</label>

        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
          <b-form-radio-group
            id="radio-gender"
            v-model="customer.gender"
            :aria-describedby="ariaDescribedby"
            name="radio-gender"
            buttons
            button-variant="outline-neutral"
            size="md"
          >
            <b-form-radio value="male" class="pc-1">Mr.</b-form-radio>
            <b-form-radio value="female" class="pc-1">Mrs.</b-form-radio>
            <b-form-radio value="other" class="pc-1">Mx.</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 inputphone"
        v-bind:class="{ 'is-invalid': $v.customer.phone.$error }"
      >
        <label class="title-label"
          ><span class="markrequired">*</span>Contact Number</label
        >
        <vue-tel-input
          v-model="phone_format"
          key="NumberPhoneCustomer"
          inputId="NumberPhoneCustomer"
          name="NumberPhoneCustomer"
          required
          mode="international"
          inputClasses="input no-label no-err"
          :dynamicPlaceholder="true"
          :disabledFetchingCountry="true"
          :validCharactersOnly="true"
          :wrapperClasses="[
            $v.customer.phone.$error ? 'is-invalid' : '',
            'mb-0'
          ]"
          @validate="phoneInput_customer"
          :inputOptions="phoneOptions"
        ></vue-tel-input>
        <small class="invalid-feedback mt-1" v-if="$v.customer.phone.$error"
          >Enter a valid phone</small
        >
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <base-input
          id="customer_email"
          name="customer_email"
          v-model.trim="email"
          label="Email Address"
          placeholder="Email Address"
          :error="
            !$v.customer.email.email || $v.customer.email.$error || !emailStatus
              ? !$v.customer.email.email || $v.customer.email.$error
                ? 'Enter a valid email'
                : `${messageEmail}`
              : ''
          "
          @input="verifyEmailCustomer"
          :successMessage="messageEmail"
          :valid="emailStatus"
          autocomplete="off"
          indexTab="5"
          markrequired
        />
      </div>

      <div class="col-12 text-right mt-4">
        <base-button
          :disabled="send"
          type="primary"
          class="min-button"
          @click="saveCustomer()"
        >
          <i class="flaticon-floppy-disk"></i>Save
        </base-button>
      </div>
    </div>
  </modal>
</template>

<script>
import lodash from "lodash";
import { mapGetters } from "vuex";
import WSelect from "@/components/Select";
import { VueTelInput } from "vue-tel-input";
import { Select } from "element-ui";
import endpoint from "../../Commons/Services/index";
import {
  required,
  minLength,
  maxLength,
  email,
  requiredIf,
  helpers
} from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);

Select.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "add-customer",
  components: {
    VueTelInput,
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    }
  },
  data() {
    return {
      customer: {
        gender: "male",
        first_name: "",
        last_name: "",
        company_name: "",
        vat_number: "",
        phone: "",
        type: "customer",
        password: "r1h2o3m4b5u6s*",
        country: "",
        city: "",
        state: "",
        zip_code: "",
        street: "",
        other_contact_platform: "",
        goverment_id: "",
        date_of_birth: "",
        mark_up: 32,
        vip: false,
        status: false,
        notes: "",
        email: "",
        session: false,
        contact_info: "",
        source: "rhombuss",
        relationship: {
          owner: "",
          type: ""
        }
      },
      email: "",
      send: false,
      type: "customer",
      loading: false,
      options: [],
      genderOptions: [
        { value: "male", label: "Mr." },
        { value: "female", label: "Mrs." },
        { value: "other", label: "Mx." }
      ],
      contact_platform: [
        { value: "Whatsapp", label: "Whatsapp" },
        { value: "Skype", label: "Skype" }
      ],
      types: [
        { value: "customer", label: "Customer" },
        { value: "travel_agency", label: "Business" }
      ],
      title: "",
      phone_format: "",
      messageEmail: "",
      emailStatus: false,
      showAndClose: false,
      phoneOptions: { tabindex: 4 }
    };
  },
  async created() {},
  watch: {
    show: {
      handler: function(current, old) {
        this.showAndClose = current;
      },
      deep: true
    }
  },
  methods: {
    async saveCustomer() {
      try {
        this.send = true;
        this.$v.customer.$touch();
        var body = lodash.cloneDeep(this.customer);
        body.relationship.owner =
          this.sesion.role === "admin" ? "" : this.getOwner();
        body.relationship.type = this.sesion.role;
        body.session = this.sesion.role === "admin" ? true : false;

        if (!this.$v.customer.$invalid && this.emailStatus) {
          let { data } = await endpoint.customers.services.createCustomer(
            body,
            "fast"
          );
          this.send = false;
          if (data.status) {
            let customer = data.data.customer;
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Customer has been Saved",
              icon: "flaticon-check-3"
            });
            this.clearData();
            this.$emit("customer", customer);
            this.$emit("closeNewCustomerModal", true);
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message:
                "There was an error saving the Customer, please try again",
              icon: "flaticon-remove"
            });
          }
        } else {
          this.send = false;
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.send = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "There was an error saving the Customer, please try again",
          icon: "flaticon-remove"
        });
      }
    },
    phoneInput_customer(payload) {
      let result = payload;
      if (result.isValid) {
        this.customer.phone = result.number.e164;
      }
    },
    async verifyEmailCustomer(event) {
      try {
        let owner = this.getOwner();
        this.customer.email = event.toLowerCase();
        if (!this.$v.customer.email.$invalid) {
          let { data } = await endpoint.auth.services.verifyCustomer(
            this.customer.email,
            owner,
            this.sesion.role
          );
          if (data.code === 200 && data.data.status) {
            this.emailStatus = true;
            this.messageEmail = "Email is valid";
          } else {
            this.emailStatus = false;
            this.messageEmail = "Email is invalid or already taken";
          }
        } else {
          this.emailStatus = false;
          this.messageEmail = "Enter a valid email address";
        }
      } catch (error) {
        this.messageEmail = "Email is invalid or already taken";
        this.emailStatus = false;
      }
    },
    getOwner() {
      return this.sesion.role === this.sesion.account_type.type
        ? this.sesion.id
        : this.sesion.account_type.owner;
    },
    clearData() {
      this.customer.gender = "male";
      this.customer.first_name = "";
      this.customer.last_name = "";
      this.customer.phone = "";
      this.customer.type = "customer";
      this.customer.email = "";
      this.email = "";
      this.phone_format = "";
      this.customer.relationship.owner = "";
      this.customer.company_name = "";
      this.customer.relationship.type = "";
      this.$v.customer.$reset();
    },
    closeModal(customer = null) {
      this.clearData();
      this.$emit("closeNewCustomerModal", false);
    }
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    customer: {
      first_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(45),
        ValName
      },
      last_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(45),
        ValName
      },
      company_name: {
        required: requiredIf(function(value) {
          return this.type === "travel_agency";
        }),
        minLength: minLength(3),
        maxLength: maxLength(45)
      },
      email: {
        required,
        email
      },
      gender: {
        required: requiredIf(function(value) {
          return this.type === "customer";
        })
      },
      phone: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(25)
      }
    }
  }
};
</script>
